import React from 'react'
import { Button, Empty, Popover, Skeleton, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import * as deepObject from 'deep-object-diff'
import { FormComponent } from '../../BaseComponent'
import { SearchRequest } from '../../../services/api/interfaces/ApiRequest'
import { ShelterKioskReasonContextData } from '../../../context/ShelterKioskReasonContext'
import KioskAddShelterReason from './AddShelterReason'
import IKioskReason from '../../../interfaces/IKioskReason'
import ShelterReason from './ShelterReason' 
import ILanguage from '../../../interfaces/ILanguage'

type KioskProps = {
  branchUuid: string,
  shelterUuid: string,
  loading: boolean,
  error: any | null,
  history: any,

  kioskReasons: IKioskReason[] | []
  languages: ILanguage[] | null

  shelterKioskReason: ShelterKioskReasonContextData

  loadKioskReason: (args: SearchRequest) => Promise<void>
  loadLanguages: (args: SearchRequest) => Promise<void>
}

export default class Kiosk extends FormComponent<KioskProps> {

  state = {
    loaded: false,
    showAddPopover: false
  }

  async componentDidMount() {
    const { branchUuid, loading, languages, shelterKioskReason, loadKioskReason, loadLanguages } = this.props

    if (!loading) {
      await loadKioskReason({
        options: {
          limit: 9999
        }
      })
    }

    if (!languages) {
      await loadLanguages({
        options: {
          _force_ids: true,
          limit: 9999
        }
      })
    }

    if (branchUuid) {
      if (!shelterKioskReason.fetching) {
        shelterKioskReason.requestShelterKioskReasonList({
          search: {
            deleted: false,
            branch: {
              with: {
                _exists: true,
                uuid: branchUuid
              }
            },
            reason: {
              with: {
                _exists: true
              }
            },
            translation: {
              with: {
                language: {
                  with: true
                }
              }
            }
          },
          options: {
            _force_ids: true
          }
        })
      }
    }
  }

  componentDidUpdate(prevProps: KioskProps, prevState: any) {
    const wasLoading = prevProps.shelterKioskReason.fetching && !this.props.shelterKioskReason.fetching
    const newState = Object.assign({}, this.state)

    if (!newState.loaded) {
      if (wasLoading) {
        newState.loaded = true
      }
    }

    const hasChanged = Object.keys(deepObject.diff(this.state, newState)).length > 0
    if (hasChanged) {
      this.setState(newState)
    }
  }

  handlePopoverVisibleChange = (visible: boolean) => {
    this.setState({
      showAddPopover: visible
    })
  }

  handleShelterKioskReasonSave = () => {
    this.setState({
      showAddPopover: false
    })
  }

  goBack = () => (
    <Button
      type="ghost"
      shape="circle"
      icon={<ArrowLeftOutlined />}
      style={{
        marginRight: 10
      }}
      onClick={() => this.props.history.goBack()}
    />
  )

  private renderAddShelterKioskReason = (children: any) => {
    const { branchUuid, shelterKioskReason, kioskReasons } = this.props
    const { showAddPopover } = this.state

    const reasonsToExclude = this.props.shelterKioskReason?.shelterKioskReasons?.map(item => item.reason?.uuid);
    // Crie um novo array filtrado
    const kioskReasonsFiltrados = kioskReasons.filter(item => !reasonsToExclude?.includes(item?.uuid));


    return (
      <Popover
        title="Add Shelter Kiosk Reason"
        content={
          <KioskAddShelterReason
            branchUuid={branchUuid}
            loading={shelterKioskReason.fetching || false}
            kioskReasons={kioskReasonsFiltrados}
            createShelterKioskReason={shelterKioskReason.requestShelterKioskReasonCreate}
            onSave={this.handleShelterKioskReasonSave}
          />
        }
        placement="left"
        trigger="click"
        visible={showAddPopover}
        onVisibleChange={this.handlePopoverVisibleChange}
      >
        {children}
      </Popover>
    )
  }

  render() {
    const { branchUuid, shelterUuid, shelterKioskReason } = this.props
    const { loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    if (shelterKioskReason.shelterKioskReasons?.length === 0) {
      const addKioskReason = (
        <>
          <Typography.Text style={{marginRight: 5}}>
            No kiosk reason found.
          </Typography.Text>

          {
            this.renderAddShelterKioskReason((
              <Typography.Link>
                Add kiosk reason
              </Typography.Link>
            ))
          }
        </>
      )

      return <Empty description={addKioskReason} />
    }

    return (
      <div>
        <ShelterReason
          branchUuid={branchUuid}
          shelterUuid={shelterUuid}
          context={shelterKioskReason}
          addButtonContent={this.renderAddShelterKioskReason((
            <Button type="primary" shape="round" size="small">
              Add
            </Button>
          ))}
          goBack={this.goBack()}
        />
      </div>
    )
  }
}
